import { Toast } from "antd-mobile";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Card, Row, Col } from "react-bootstrap";
import { useParams, useNavigate } from "react-router-dom";
import { ServiceUrl } from "../../utils/serviceUrl";
import Header from "../header";

const InternalCircularView = () => {
  const [loader, setLoader] = useState(false);
  const [internalCircularview, setInernalCircularview] = useState([]);
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    setLoader(true);
    axios
      .post(ServiceUrl.MOB.LIST_INTENAL_CIRUCULAR + "?id=" + `${id}`)
      .then((res) => {
        if (res.data.status === "1") {
          setInernalCircularview(res.data.data);
        } else {
          Toast.show({ content: res.data.message || "Error" });
        }
        setLoader(false);
      });
  }, [id]);

  return (
    <>
      <Header
        title="Internal Circular Details"
        backAction={true}
        rightActions={[]}
        onBack={() => navigate(-1)}
      />
      <div className="container">
        {internalCircularview.map((circular, index) => (
          <Card key={index} style={styles.card}>
            <Card.Header style={styles.header}>
              <h2 style={styles.title}>{circular.title}</h2>
            </Card.Header>
            <Card.Body>
              <Row style={styles.row}>
                <Col md={6}>
                  <p style={styles.label}>
                    <strong>Create Date :</strong> {circular.created_on}
                  </p>
                </Col>
                <Col md={6}>
                  <p style={styles.label}>
                    <strong>Circular For:</strong> {circular.circular_for}
                  </p>
                </Col>
              </Row>
              <Row style={styles.row}>
                <Col md={6}>
                  <p style={styles.label}>
                    <strong>Circular To :</strong> {circular.circular_to}
                  </p>
                </Col>
                <Col md={6}>
                  <p style={styles.label}>
                    <strong>Publish Date :</strong> {circular.publish_date}
                  </p>
                </Col>
              </Row>
              <Row style={styles.row}>
                <Col md={6}>
                  <p style={styles.label}>
                    <strong>Department:</strong> {circular.department}
                  </p>
                </Col>
                <Col md={6}>
                  <p style={styles.label}>
                    <strong>Circular Type:</strong> {circular.circular_type}
                  </p>
                </Col>
              </Row>
              <Row style={styles.row}>
                <Col md={6}>
                  <p style={styles.label}>
                    <strong>Circular Number:</strong> {circular.circular_number}
                  </p>
                </Col>
                <Col md={6}>
                  <p style={styles.label}>
                    <strong>Circular Activities:</strong>{" "}
                    {circular.circular_activities}
                  </p>
                </Col>
              </Row>
              <Row style={styles.row}>
                <Col md={6}>
                  <p style={styles.label}>
                    <strong>Circular Date:</strong> {circular.circular_date}
                  </p>
                </Col>
                <Col md={6}>
                  <p style={styles.label}>
                    <strong>Publish Date:</strong> {circular.publish_date}
                  </p>
                </Col>
              </Row>
              <Row style={styles.row}>
                <Col md={6}>
                  <p style={styles.label}>
                    <strong>Expired Date:</strong> {circular.expired_date}
                  </p>
                </Col>
                <Col md={6}>
                  <p style={styles.label}>
                    <strong>Activities:</strong> {circular.circular_activities}
                  </p>
                </Col>
              </Row>

              <Row style={styles.row}>
                <Col md={12}>
                  <p style={styles.label}>
                    <strong>Content: </strong>{" "}
                    <span>{circular.content || "No content available"}</span>
                  </p>
                </Col>
              </Row>
              <Row style={styles.row}>
                <Col md={12}>
                  <p style={styles.label}>
                    <strong>Uploaded Files:</strong>{" "}
                    {circular.upload_files ? (
                      <a
                        href={circular.upload_files}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={styles.fileLink}
                      >
                        View File
                      </a>
                    ) : (
                      "No files uploaded"
                    )}
                  </p>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        ))}
      </div>
    </>
  );
};

const styles = {
  card: {
    padding: "20px",
    marginTop: "20px",
    borderRadius: "8px",
    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
    border: "1px solid #ddd",
  },
  header: {
    backgroundColor: "#f8f9fa",
    padding: "10px 20px",
    borderBottom: "1px solid #e0e0e0",
  },
  title: {
    fontSize: "24px",
    fontWeight: "bold",
    margin: 0,
    color: "#333",
  },
  row: {
    marginBottom: "10px",
  },
  label: {
    fontSize: "16px",
    color: "#555",
  },
  fileLink: {
    color: "#007bff",
    textDecoration: "none",
  },
};

export default InternalCircularView;
